import { Icon } from '@iconify/react';

export const COURSES = [
  {
    title: 'ফার্ষ্ট টাইম মেডিকেল এ্যাডমিশন ব্যাচ',
    description: "যারা সেকেন্ডটাইম এক্সাম দিবে মেডিকেলে, সেকেন্ডটাইম ব্যাচ, ' গোল ডিগার্স ৩.১ (S).",
    image: '/img/asif/course/dr_asif_batch_first_timer.jpg',
    price: 10000,
    discountedPrice: 6000,
    teachers: 'Dr. Asif & K@bir Sizer',
    time: '12 months',
  },
  {
    title: 'সেকেন্ড টাইম মেডিকেল এ্যাডমিশন ব্যাচ',
    description: "যারা সেকেন্ডটাইম এক্সাম দিবে মেডিকেলে, সেকেন্ডটাইম ব্যাচ, ' গোল ডিগার্স ৩.১ (S).",
    image: '/img/asif/course/dr_asif_batch_2nd_timer.jpg',
    price: 10000,
    discountedPrice: 6000,
    teachers: 'Dr. Asif & K@bir Sizer',
    time: '12 months',
  },
  {
    title: 'ICT Batch',
    description: "যারা সেকেন্ডটাইম এক্সাম দিবে মেডিকেলে, সেকেন্ডটাইম ব্যাচ, ' গোল ডিগার্স ৩.১ (S).",
    image: '/img/asif/course/dr_asif_batch_ict.jpg',
    price: 10000,
    discountedPrice: null,
    teachers: 'Dr. asif, K@bir Sizer Dr. Sajib( Dmc)',
    time: '12 months',
  },
  {
    title: 'এইচ.এস.সি বায়োলজি গোল্ডেন ব্যাচ',
    description: "যারা সেকেন্ডটাইম এক্সাম দিবে মেডিকেলে, সেকেন্ডটাইম ব্যাচ, ' গোল ডিগার্স ৩.১ (S).",
    image: '/img/asif/testing-green.jpg',
    price: 10000,
    discountedPrice: 6000,
    teachers:
      'Dr.Asif Dr. Sajib( Dmc), Dr. Ariful islam(Shsmc), Dr.Mithun(Ssmc) Dr. Kayes(Kmc), Dr. Jahin(kmc), Dr. Abidur Rahman(kmc) Dr.Mehrab(kmc),Dr. Hridoy(kmc Dr. Nayoy shaha(kmc)',
    time: '12 months',
  },
];

export const BOOKS = [
  {
    title: '𝐒𝐮𝐩𝐫𝐞𝐦𝐞 𝐁𝐨𝐨𝐤',
    description:
      'এখানে প্রাণিবিজ্ঞানের যেসকল বইয়ের তথ্য এ্যাড করা হয়েছে:' +
      '=> গাজী আজমল, ড. আলীম, মাজেদা ম্যাডাম, আবুল হাসান ও আজিবুর রহমান স্যারের বই।' +
      '=> উদ্ভিদ বিজ্ঞান: আবুল হাসান, ড. আলীম, গাজী আজমল।\n' +
      '=> পদার্থ বিজ্ঞান: ইসহাক, শাহজাহান তপন, তফাজ্জল হোসেন, অক্ষরপত্র।\n' +
      '=> রসায়ন বিজ্ঞান: হাজারী ও নাগ, কবির স্যার ও সঞ্জিত কুমার গুহ স্যার।\n',
    image: '/img/asif/books/dr_asif_supreme_book.jpg',
  },
  {
    title: '𝐒𝐩𝐞𝐜𝐢𝐚𝐥 𝐐𝐮𝐞𝐬𝐭𝐢𝐨𝐧 𝐁𝐚𝐧𝐤',
    description:
      'প্রতিটা বইয়ের অধ্যায়ভিত্তিক অনুশীলনীর প্রশ্নগুলো বরাবরই গুরুত্বপূর্ণ। আমাদের প্রশ্ন ব্যাংকে উপোরক্ত সকল রাইটারের অনুশীলনীর প্রশ্ন সলভ করে দেয়ার পাশাপাশি বিগত ১৫ বছরের মেডিকেল ও ডেন্টালের প্রশ্নের সলভ রয়েছে।',
    image: '/img/asif/books/dr_asif_question_bank.jpg',
  },
  {
    title: '𝐏𝐫𝐚𝐜𝐭𝐢𝐜𝐞 𝐁𝐨𝐨𝐤',
    description:
      'স্টুডেন্টদের রেগুলার যে অধ্যায়গুলা পড়ানো হয়, তার উপর পরদিন লেকচারের শুরুতে ৫০ নম্বরের MCQ পরিক্ষা নেওয়া হয়। তারপরও স্টুডেন্টরা যাতে বাসায় পড়া শেষ করে বাসায় বসেই এক্সট্রা পরিক্ষা দিতে পারে তার জন্য আমাদের প্র্যাকটিস বুকে অধ্যায়ভিত্তিক ৫০টি করে প্রশ্ন সংযোজন করা হয়েছে। শেষে উত্তর দেয়া রেয়েছে। প্রতিটি অধ্যায় শেষ করে স্টুডেন্টরা যাতে বারবার পরিক্ষা দিয়ে নিজেদের পড়াটা ঝালিয়ে নিতে পারে সেজন্য আমাদের এই ব্যবস্থা। আমরা বিশ্বাস করি, Practice makes a man perfect.',
    image: '/img/asif/books/dr_asif_practice_book.jpg',
  },
  {
    title: '𝐄𝐧𝐠𝐥𝐢𝐬𝐡 𝐅𝐨𝐫 𝐌𝐞𝐝𝐢𝐜𝐚𝐥 𝐂𝐚𝐦𝐩𝐮𝐬',
    description:
      'মেডিকেল ভর্তি পরীক্ষায় অসংখ্য স্টুডেন্টের ভালো প্রিপারেশন থাকা সত্বেও শুধুমাত্র ইংরেজিতে খারাপ করার কারনে চান্স পেতে ব্যর্থ হয়। 𝐄𝐧𝐠𝐥𝐢𝐬𝐡 𝐅𝐨𝐫 𝐌𝐞𝐝𝐢𝐜𝐚𝐥 𝐂𝐚𝐦𝐩𝐮𝐬 বইটি শুধুমাত্র মেডিকেল ও ডেন্টাল এ্যাডমিশন 𝐄𝐧𝐠𝐥𝐢𝐬𝐡 সিলেবাসের উপর লিখিত দেশের অপ্রতিদ্বন্দ্বী ইংরেজি বই।এখন দেশের স্বনামধন্য সকল লাইব্রেরিতে পাওয়া যাচ্ছে।ডাঃ আসিফ মেডিকেল ব্যাচে ভর্তি হলেই থাকবে 𝐄𝐧𝐠𝐥𝐢𝐬𝐡 𝐅𝐨𝐫 𝐌𝐞𝐝𝐢𝐜𝐚𝐥 𝐂𝐚𝐦𝐩𝐮𝐚𝐬 বইয়ের 𝐖𝐫𝐢𝐭𝐞𝐫 𝐊@𝐛𝐢𝐫 𝐒𝐢𝐳𝐞𝐫 এর সব 𝐄𝐱𝐜𝐥𝐮𝐬𝐢𝐯𝐞 𝐂𝐥𝐚𝐬𝐬|| ১০০% প্রিপারেশনে আমরা আপোষহীন॥',
    image: '/img/asif/books/kabir_sizer_english_for_medical_campus.jpg',
  },
  {
    title: '𝐆𝐤 𝐅𝐨𝐫 𝐌𝐞𝐝𝐢𝐜𝐚𝐥 𝐂𝐚𝐦𝐩𝐮𝐬',
    description:
      'একমাত্র বই যেটা শুধুমাত্র মেডিকেল ও ডেন্টাল সিলেবাসের উপর লিখিত সাধারন জ্ঞানের বই।পরীক্ষার ঠিক আগ মুহুর্তে রিভিশন দেওয়ার জন্য সব থেকে পারফেক্ট একটি বই।',
    image: '/img/asif/books/kabir_sizer_gk.jpg',
  },
];

export const reviews = [
  {
    studentName: 'তৌফিকা রহমান নিহা',
    descriptionAboutRank: 'ঢাকা মেডিকেল কলেজ (জাতীয় মেধায় ২য়)',
    studentImage: '/public/img/asif/review/04.jpg',
    review:
      ' মহান আল্লহার অশেষ রহমতে আমি মেডিকেল ভর্তি পরীক্ষায় জাতীয় মেধায় ২য় স্থান অধিকার করেছি। মেডিকেল এ্যাডমিশনের জন্য আমি প্রথম থেকে ডাঃ আসিফ ও K@bir Sizer ভাইয়ার ব্যাচে ভর্তি ছিলাম। সত্যি বলতে আজকের অবস্থানের জন্য ডাঃ আসিফ ও K@bir Sizer ভাইয়ার পড়ানোটা খুবই কাজে লেগেছে।ভাইয়াদের প্রতিটা লেকচার খুব সুন্দর করে গোছানো থাকে, যা এ্যাডমিশনের সময়ে অন্যদের থেকে সব সময় একধাপ এগিয়ে রাখে। মেইন বইয়ের পাশাপাশি ভাইয়াদের প্রকাশিত বইগুলো আমি পড়েছি এবং আমার কাছে বইগুলো যুগোপযোগী সিন্ধান্ত বলে মনে করি। সর্বোপরি বলতে চাই মেডিকেলে অতি সহজেই চান্স পেতে তথা গায়ে সাদা অ্যাপ্রোণ জড়াতে চাইলে ভাইয়াদের বিকল্প আছে বলে আমি মনে করি না। সর্বোপরি আমি ডাঃ আসিফ ও K@bir Sizer ভাইয়া সহ Medi Inn পরিবারর সকলের উত্তরোত্তর সাফল্য কামনা করছি।',
  },
  {
    studentName: 'ফারিয়া তাবাস্সুম অর্পি',
    descriptionAboutRank: 'ঢাকা মেডিকেল কলেজ ( জাতীয় মেধায় ৫ম)',
    studentImage: '/public/img/asif/review/03.jpg',
    review:
      'আমি মেডিকেল ভর্তি পরীক্ষায় অংশ নিয়ে জাতীয় মেধায় 5ম স্থান অর্জন করেছি। আমি এ্যাডমিশনের সময় শুরু থেকে শেষ পর্যন্ত  ডাঃ আসিফ ও K@bir Sizer ভাইয়ার সম্পূর্ণ গাইডলাইনে ছিলাম। এই প্রতিযোগীতার বাজারে এত মেধামী শিক্ষার্থীদের মধ্যে একমাত্র সঠিক সিন্ধানই অন্যদের থেকে পার্থক্য করে দিতে পারে। এ্যাডমিশনের শুরু থেকেই ভাইয়ারা খুটিনাটি বিষয়গুলো সুন্দর ভাবে বুঝিয়ে আমাদের ক্লিয়ার করে দিতেন। মেডিকেল এ্যাডমিশনের সময় ডাঃ আসিফ ভাইয়া সর্বপ্রথম মেইন বই গুলো  ক্লিয়ার করে  দিতেন। তারপরে অন্যান্য রাইটারের গুরুত্বপূর্ণ তথ্য গুলো একসঙ্গে করে সীট ও বই আকারে আমাদের কাছে উপস্থাপন করতেন। যার ফলে  ভর্তি পরীক্ষায় স্টুডেন্টরা অন্যদের তুলনায় বেশি আত্নবিশ্বাস নিয়ে পরীক্ষার হলে যেতে পারে। পরিশেষে একথা আমি সিঃসন্দেহে বলতে পারি যে, অনলাইন, অফলাইন উভয় ক্ষেত্রেই ভাইয়ারা অন্যান্যদের তুলনায় সুদীর্ঘ অভিজ্ঞতার আলোকে একধাপ এগিয়ে। এর পাশাপাশি ভাইয়ারা আমার জীবনের অন্যতম শ্রেষ্ঠ শিক্ষক হিসেবে সারাজীবন বেঁচে থাকবে ইনশাআল্লাহ।',
  },
  {
    studentName: 'অর্পিতা',
    descriptionAboutRank: 'ঢাকা মেডিকেল কলেজ (জাতীয় মেধায় ৯ম)',
    studentImage: '/public/img/asif/review/05.jpg',
    review:
      'খুলনা সিটি কলেজ থেকে ২০২১ সালে এইচএসসি পাশ করেছি এবং ২০২১-২২ শিক্ষাবর্ষে মেডিকেল ভর্তি পরীক্ষায় জাতীয় মেধায় নবম স্থান অধিকার করে ঢাকা মেডিকেল কলেজে পড়ার সুযোগ পেয়েছি। আমার এই মেডিকেল এডমিশন জার্নির শুরু থেকেই আমি ডাঃ আসিফ ভাইয়া ও K@bir Sizer ভাইয়ার তত্ত্বাবধানে ছিলাম। সত্যি বলতে আমার সাফল্যের পিছনে তাদের ভূমিকা উল্লেখযোগ্য। ডাঃ আসিফ ভাইয়ার ব্যাচের সব থেকে অসাধারণ একটা দিক হচ্ছে সপ্তাহে তিন দিন পদার্থবিজ্ঞান, জীববিজ্ঞান ও রসায়নের ক্লাস এবং অপর তিনদিন ইংরেজি ও সাধারণ জ্ঞানের ক্লাস। যার কারনে আমি physics, chemistry ও Biology এর  পাশাপাশি English ও GK তেও নিজের প্রস্তুতিকে সর্বোচ্চ পর্যায়ে নিয়ে যেতে পেরেছি। তাই জুনিয়রদের উদ্দেশ্যে বলবো তোমাদের ডাক্তার হওয়ার স্বপ্ন পূরণের জন্য ডাঃ আসিফ ভাইয়ার ব্যাচ এক কথায় The best।',
  },
  {
    studentName: 'অর্থি',
    descriptionAboutRank: 'ঢাকা মেডিকেল কলেজ ( জাতীয় মেধায় ৫ম)',
    studentImage: '/public/img/asif/review/06.jpg',
    review:
      'খুলনা সরকারি মহিলা কলেজের একজন প্রাক্তন শিক্ষার্থী,  ২০২০-২১ শিক্ষাবর্ষে ডেন্টাল ভর্তি পরীক্ষায় জাতীয় মেধায় ৫ম হয়ে ডেন্টালে পড়ার সুযোগ পেয়েছি। আমি আমার মেডিকেল ভর্তি পরীক্ষার সময় পুরোটার সময় জুড়ে ডাঃআসিফ এবং K@bir Sizer ভাইয়ের গাইডলাইনে ছিলাম।  ডাঃ আসিফ ভাইয়ের প্রতিটা ক্লাসই এক কথায় অসাধারণ, ক্লাসগুলো যেমন সুন্দর করে গোছানো , তেমনি বেসিক থেকে এডমিশন পর্যন্ত আলোচনা করা।  আর অতিরিক্ত তথ্যের জন্য ডাঃ আসিফ ভাইয়ের নিজের তৈরী করা সুপ্রিম বুক তো আছেই, পাশাপাশি কবির সিজার ভাইয়ের জিকে ও ইংরেজি লেকচার গুলোর সত্যিই তুলনা হয় না,স্পেশালি সিজার ভাইয়ের লেখা English for Medical Campus। এক কথায় আমার কাছে ডাঃ আসিফ ভাইয়া ও সিজার ভাইয়ার সার্ভিস সব থেকে সেরা মনে হয়েছে। তাই জুনিয়রদের বলবো গায়ে সাদা অ্যাপ্রন জড়াতে চাইলে ডাঃ আসিফ ভাইয়ের ব্যাচই হবে তোমাদের জন্য সেরা choice।',
  },
  {
    studentName: 'ডা:তনুশ্রী ডাকুয়া, বিসিএস (স্বাস্থ্য)',
    descriptionAboutRank: 'ঢাকা মেডিকেল কলেজ (জাতীয় মেধায় ১৪৫ তম)',
    studentImage: '/public/img/asif/review/02.jpg',
    review:
      '২০১৪  সালে মেডিকেল ভর্তি পরীক্ষায় সারা বাংলাদেশে ১৪৫ স্থান অর্জন করি। ডাক্তার হওয়ার ইচ্ছা ছোটবেলা থেকেই। ২০১৪ সালের বাগেরহাট সরকারি পি,সি কলেজ থেকে এইচ এস সি  পরীক্ষার পরেই ডাঃ আসিফ স্যারের মেডিকেল প্রাইভেট ব্যাচে ভর্তি হই। আমার মতে আজকের এই অবস্থানের জন্য ডাঃ আসিফ ভাইয়া এবং সিজার ভাইয়ের ভূমিকা অত্যন্ত গুরুত্বপূর্ণ ছিল। এখানে আমি সপ্তাহে ছয় দিন ক্লাস করেছি। প্রতিনিয়ত ক্লাস আর পরীক্ষার মাধ্যমে সম্পূর্ণ সিলেবাস একবার শেষ করার পরে যখন অন্য স্টুডেন্টরা ইংলিশ ও জিকে সহ অন্য বিষয়গুলো কিভাবে বারবার রিভাইস দিতে হবে বুঝে উঠতে পারছিল না ঠিক তখনই ডাঃ আসিফ ভাইয়া আর সিজার ভাইয়া আমাদেরকে সঠিক গাইডলাইন আর রুটিন এর মাধ্যমে বারবার প্রতিটা বই শেষ করিয়ে দিয়েছিলেন। তাদের প্রতিটা লেকচারই অসাধারণ সুন্দর ছিল। তাই আমি আমার জুনিয়রদের বলতে চাই তোমরাও যদি ডাক্তার হওয়ার স্বপ্ন দেখো তাহলে নির্দ্বিধায় ডাঃ আসিফ ভাইয়ের ব্যাচে ভর্তি হতে পারো।',
  },
];

export const contactInfo = [
  {
    media: 'Facebook',
    Icon: <Icon icon="ri:facebook-fill" style={{ fontSize: '25px' }} />,
    link: 'https://www.facebook.com/profile.php?id=100094307029795&mibextid=LQQJ4d',
    followers: '2.3k',
    info: 'Facebook',
    backgroundColor: '#D0F2FF',
    color: '#1877F2',
  },
  {
    media: 'Youtube',
    Icon: <Icon icon="bi:youtube" style={{ fontSize: '25px' }} />,
    link: 'https://youtube.com/@MediInn?si=36pPdyVtsTLSD3aj',
    followers: '2.3k',
    info: 'Youtube',
    backgroundColor: '#FFE7D9',
    color: 'red',
  },
  {
    media: 'Phone',
    Icon: <Icon icon="mingcute:phone-fill" style={{ fontSize: '25px' }} />,
    link: '#',
    followers: '2.3k',
    info: '01742-481277',
    backgroundColor: '#D1E9FC',
    color: 'blue',
  },
  {
    media: 'Gmail',
    Icon: <Icon icon="bxl:gmail" style={{ fontSize: '25px' }} />,
    link: '#',
    info: 'drasifmedicalprivatebatch@gmail.com',
    backgroundColor: '#f7cfcd',
    color: '#DF3E30',
  },
];

export const achivements = [
  '/public/img/asif/achivements/1.jpg',
  '/public/img/asif/achivements/2.jpg',
  '/public/img/asif/achivements/3.jpg',
  '/public/img/asif/achivements/4.jpg',
  '/public/img/asif/achivements/5.jpg',
  '/public/img/asif/achivements/6.jpg',
  '/public/img/asif/achivements/7.jpg',
];

// export const colors = ["#FFF7CD", "#D0F2FF", "#FFE7D9", '#DFEBE9' ]

// export const borderColors = ['orange', 'blue', 'red', 'green']

export const colors = ['#DFEBE9', '#FFE7D9', '#D0F2FF', '#FFF7CD'];

export const borderColors = ['green', 'red', 'blue', 'orange'];
